/**
 * Created by Josef Jurca on 2.11.2017.
 */

import { ActionTypes } from "../actions/config";

const defaultState = {
  seaChange: {},
};


const config = (state = defaultState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_CONFIG:
      return {
        ...state,
        seaChange: { ...payload },
      };

    default:
      return state;
  }
};


export default config;


// WEBPACK FOOTER //
// ./src/js/store/reducers/config.js